import React from 'react';
import '../../styles/CloseButton.css';

/**
 * Кнопка закрытия (крестик), используется для закрытия модальных окон.
 *
 * @component
 * @param {Object} props - Свойства компонента.
 * @param {function} props.onClose - Функция, вызываемая при клике на кнопку закрытия.
 * @returns {JSX.Element} Кнопка закрытия.
 */

function CloseButton({ onClose }) {
  return (
    <button id="close_button" className="close-btn" onClick={onClose}>
      <span className="close-icon" aria-hidden="true">
        &times;
      </span>
    </button>
  );
}

export default CloseButton;
